import type { ReactNode } from 'react';
import { memo } from 'react';

export interface ProfileOverviewCardContentProps {
  children: ReactNode;
}

export const ProfileOverviewCardContent = memo(
  (props: ProfileOverviewCardContentProps) => {
    const { children } = props;

    return (
      <div className="flex w-full shrink-0 flex-col gap-2">{children}</div>
    );
  },
);
